import { combineReducers } from "redux-immutable";
import userReducer from "UserAuthorized/reducers";
import authorizeLinkReducer from "AuthorizeLink/reducer";

const rootReducer = combineReducers({
  ...userReducer,
  ...authorizeLinkReducer
});

export default rootReducer;
